import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaTruck } from "react-icons/fa";
import { IoDocumentText } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { AmbikaVenderApi } from "./config";
import { FaFileAlt } from "react-icons/fa";

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="col-lg-6 col-md-8 col-11 m-auto my-4">
        <div class="d-flex align-items-center justify-content-between gap-2  flex-sm-row flex-column boxSadow2">
          <button
            class="btn btn-success form-control rounded-5 text-nowrap"
            onClick={() => navigate("/load-truck-items")}
          >
            {" "}
            <FaTruck class="mx-sm-2 mx-1" /> Load truck Item
          </button>
          {/* <button class='btn btn-success form-control rounded-5 text-nowrap' onClick={()=>navigate('/load-truck-summary')}> <IoDocumentText class='mx-sm-2 mx-1' /> Loaded Item Summary</button> */}
          <button
            class="btn btn-success form-control rounded-5 text-nowrap"
            onClick={() => navigate("/loaded-item-summarys")}
          >
            {" "}
            <FaFileAlt class="mx-sm-2 mx-1" /> Loaded Item Summary
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
